import { render, staticRenderFns } from "./BookFragments.vue?vue&type=template&id=2405cc6b"
import script from "./BookFragments.vue?vue&type=script&lang=js"
export * from "./BookFragments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports